module.exports = __webpack_public_path__ + "static/img/img-product-6.25a7cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/img-product-6.png
// module id = BC7C
// module chunks = 0